import BulkUpdatePolygonApi from "../../services/api/BulkUpdatePolygon";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";

function handleError(err) {
  console.log("error in bulk update polygon:", err);
}

export const bulkUpdatePolygon = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await BulkUpdatePolygonApi.bulkUpdatePolygon(payload);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.FILE_UPLOAD_FAILED,
      })
    );
    handleError(err);
  }
};